import React, { FC } from 'react';

interface Props {
  label: string;
  value?: string | number;
}

const ViewItem: FC<Props> = ({ label, value }) => (
  <div style={{ marginBottom: '1rem' }}>
    {label} {value ?? '—'}
  </div>
);

export default ViewItem;
